import { useToastStore, type ToastKind } from '@/stores/toastStore';

export const useToast = () => {
  const push = useToastStore((s) => s.push);

  return {
    info: (message: string, duration = 3500) => push({ kind: 'info', message, duration }),
    success: (message: string, duration = 3500) => push({ kind: 'success', message, duration }),
    warn: (message: string, duration = 4500) => push({ kind: 'warning', message, duration }),
    error: (message: string, duration = 5500) => push({ kind: 'error' as ToastKind, message, duration }),
  };
};
